(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('openresaBookingService', openresaBookingService);

    function openresaBookingService($q, swif, openresaBookableService) {
        'ngInject';
    	var service = {};
    	service.collectionName = 'bookings';
    	service.content_type = 'reservation';
    	service.COLLECTION_FIELDS = ['checkin', 'checkout', 'state', 'reservation_line', 'recurrence_id'];
      // 'isSpecificDiscount', 'isGlobalDiscount'
        service.COLLECTION_SLOW_FIELDS = ['all_dispo', 'actions'];
        service.MODEL_FIELDS = [
            'is_event', 'event_type_id', 'name', 'note', 'actions', 'request_id',
            'prestation_order_ids', 'attendee_ids', 'key_ids',
            'event_date_start', 'event_date_end', 'prestations_note',
            'expected_people', 'referent_people', 'referent_people_phone',
            'event_priced', 'event_price_details',
            'enable_checkin', 'enable_checkout',
            'checkin_date', 'checkout_date', 'whole_day',
            'checkin_done_date', 'checkout_done_date',
            'checkin_note', 'checkout_note',
            'checkin_state', 'checkout_state',
            'checkin_send_mail', 'checkout_send_mail',
            'checkin_mail_sent', 'checkout_mail_sent',
            'enable_key_checkin', 'enable_key_checkout',
            'key_checkin_date', 'key_checkout_date',
            'key_checkin_done_date', 'key_checkout_done_date',
            'key_checkin_note', 'key_checkout_note',
            'key_checkin_state', 'key_checkout_state',
            'key_checkin_send_mail', 'key_checkout_send_mail',
            'key_checkin_mail_sent', 'key_checkout_mail_sent',
            'recipient', 'recipient_phone', 'shipping_address', 'shipping_wished_date'
        ];

	    service.getCollection = getCollection;
	    service.initCollection = initCollection;
        service.fetchSlowFields = fetchSlowFields;

	    service.init = init;
	    service.fetch = fetch;
        service.preSanitize = preSanitize;
        service.save = save;
        service._updateOnWholeDay = _updateOnWholeDay;

	    function getCollection () {
            return swif.collections.getCollection(service.collectionName);
        }

        function initCollection (filter, options) {
            var ret = $q.defer();
            if (!options) {
                options = {};
            }
            var f = {};
            if (filter) {
                f = angular.copy(filter);
            }
            swif.data.addFilter(f, 'is_template', '=', false);
            f.fields = _.union(f.fields || [], service.COLLECTION_FIELDS);
            if (options.slowFields) {
                _.union(f.fields, service.COLLECTION_SLOW_FIELDS);
            }
            return swif.collections.createOrUpdate(
            	service.collectionName,
            	service.content_type,
            	f,
            	options
            ).then(function (coll) {
                // prepare fetched items
                _.forEach(coll.items, function (elt) {
                    init(elt);
                });
                return coll;
            });
        }

        function fetchSlowFields (bookings, filter) {
            var f = {};
            if (filter) {
                f = angular.copy(filter);
            }
            swif.data.addFilter(f, 'id', 'in', _.pluck(bookings, 'id'));
            if (!f.limit) {
                swif.data.setLimit(f, 0);
            }
            if (!f.fields) {
                f.fields = service.COLLECTION_SLOW_FIELDS;
            }
            return swif.data.get(service.content_type, undefined, f)
            .then(function (data) {
                swif.data.updateFromList(data, bookings);
                return bookings;
            });
        }

        function init (model) {
            if (!model) {
                model = {};
            }
            var defaults = {
                lines: [],
                deleted_lines: [],
                state: 'waiting',
                attendees: [],
                prestations: [],
                keys: [],
                recurrence: false,
                _bookingNotice: 0,
                _activateRecurrence: false
            };
            _.forEach(model.reservation_line || [], function (elt) {
                defaults.lines.push({id: elt});
            });
            _.defaults(model, defaults);
            // ensure content_type of the record
            model._type = service.content_type;
            return model;
        }

        function _fetchBooking (model) {
            var filter = {};
            filter.fields = service.MODEL_FIELDS;
            return swif.data.get(service.content_type, model.id, filter)
            .then(function (data) {
                // merge data only if it doesn't remove a current value in model
                _.forOwn(data, function (val, key) {
                    if (val || !model[key]) {
                        model[key] = val;
                    }
                });
                return true;
            });
        }

        function _fetchBookingLines (model, fetchBookable) {
            var filter = {};
            swif.data.setLimit(filter, 0);
            filter.fields = [
              'available_qty', 'pricelist_amount', 'product_id', 'qty',
              'actions', 'bookable_notice', 'checkin_note', 'checkout_note',
              'checkin_bookable_state', 'checkout_bookable_state', 'puj',
              'discount_puj', 'discount_pp', 'isSpecificDiscount', 'isGlobalDiscount', 'package_price'];
            swif.data.addFilter(filter, 'id', 'in', model.reservation_line);
            swif.data.sortOn(filter, 'product_id', 'ASC');
            return swif.data.get('reservation_line', undefined, filter)
            .then(function (data) {
                var defers = [];
                model.dailyTotal = 0;
                model.dailyTotalDiscount = 0;
                _.forEach(data, function (line) {
                    if(line.product_id && fetchBookable) {
                        defers.push(
                            openresaBookableService.fetch(line.product_id[0])
                            .then(function (resource) {
                                line.resource = resource;
                            })
                        );
                    }
                    var notice = moment.utc().add(line.bookable_notice || 0, 'hours');
                    line._deadlineNotice = notice.format('YYYY-MM-DD HH:mm:ss');

                    model.isPercent = true;
                    // compute discount in euro
                    line.discountEuroPuj = line.puj * (line.discount_puj / 100);
                    line.discountEuroPP = line.package_price * (line.discount_pp / 100);
                    // compute the price per day of a reservation_line
                    line.dailyDiscountedPrice = (line.puj - (line.puj * (line.discount_puj / 100))) * line.qty;
                    // compute total price per day without discount
                    model.dailyTotal += line.puj * line.qty;
                    model.dailyTotalDiscount += line.dailyDiscountedPrice;
                });
                return $q.all(defers).then(function () {
                    swif.data.updateFromList(data, model.lines);
                    openresaBookableService._computeLineAvailability(model);
                    return true;
                });
            });
        }

        function _fetchAttendees (model) {
            var filter = {fields: ['name', 'note', 'email', 'user_id', 'state', 'send_date']};
            swif.data.setLimit(filter, 0);
            swif.data.addFilter(filter, 'id', 'in', model.attendee_ids);
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.data.get('reservationAttendee', undefined, filter)
            .then(function (data) {
                _.forEach(data, function (item) {
                    if (item.user_id) {
                        item.user = {id: item.user_id[0], name: item.user_id[1]};
                    }
                });
                swif.data.updateFromList(data, model.attendees);
                return true;
            });
        }

        function _fetchPrestations (model) {
            var filter = {};
            swif.data.setLimit(filter, 0);
            swif.data.addFilter(filter, 'id', 'in', model.prestation_order_ids);
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.data.get('reservationPrestation', undefined, filter)
            .then(function (data) {
                swif.data.updateFromList(data, model.prestations);
                return true;
            });
        }

        function _fetchKeys (model) {
            var filter = {};
            swif.data.setLimit(filter, 0);
            swif.data.addFilter(filter, 'id', 'in', model.key_ids);
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.data.get('reservationKey', undefined, filter)
            .then(function (data) {
                _.forEach(data, function (item) {
                    item.key = {id: item.key_id[0], name: item.key_id[1]};
                });
                swif.data.updateFromList(data, model.keys);
                return true;
            });
        }

        /* load ALL data (lines, availability, etc...)
        @param options = {
            booking: true,
            lines: true,
            bookables: true,
            attendees: false,
            keys: false,
            prestations: false
        }
        */
        function fetch (model, options) {
            if (!options) {
                options = {};
            }
            // i use '!== false' for options default to true
            var fetchBookable = options.bookables !== false;
            var bookingDefer = $q.when(true);
            if (options.booking !== false) {
                bookingDefer = _fetchBooking(model);
                model.bookingFetched = true;
            }
            return bookingDefer.then(function () {
                var defers = [];
                if (options.lines !== false) {
                    defers.push(_fetchBookingLines(model, fetchBookable));
                    model.linesFetched = true;
                }
                if (options.attendees) {
                    defers.push(_fetchAttendees(model));
                    model.attendeesFetched = true;
                }
                if (options.keys) {
                    defers.push(_fetchKeys(model));
                    model.keysFetched = true;
                }
                if (options.prestations) {
                    defers.push(_fetchPrestations(model));
                    model.prestationsFetched = true;
                }
                return $q.all(defers).then(function () {
                    model.fetched = true;
                    return true;
                });
            });
        }

            /* sanitize data, to compute the reservation_line new values:
              - if line already exists, we perform an update
              - else, we perform a create
              - for deletedLines, we perform an unlink */
            function preSanitize (model) {
                function preSanitizeLine (line) {
                    var data = {
                        product_id: line.product_id ? line.product_id[0]: false,
                        qty: line.qty,
                        pricelist_amount: line.pricelist_amount,
                        checkin: model.checkin,
                        checkout: model.checkout,
                        checkin_note: line.checkin_note || '',
                        checkout_note: line.checkout_note || '',
                        checkin_bookable_state: line.checkin_bookable_state || false,
                        checkout_bookable_state: line.checkout_bookable_state || false
                    };
                    // Add fields puj and discount to be saved
                    data.puj = line.puj || 0;
                    data.package_price = line.package_price || 0;
                    data.discount_puj = line.discount_puj || 0;
                    data.discount_pp = line.discount_pp || 0;
                    // bubble the state to the booking_lines state
                    if (model.state && model._type === 'reservation') {
                        data.state = model.state;
                    } else if (model._type !== 'reservation') {
                        // for recurrence, force state to 'inactive'
                        data.state = 'inactive';
                    }
                    return data;
                }

                model.isSpecificDiscount = model.isSpecificDiscount || false;
                model.isGlobalDiscount = model.isGlobalDiscount || false;

                model.reservation_line = swif.data.prepareOne2manyValues(
                    model.reservation_line || [],
                    model.lines,
                    preSanitizeLine
                );

                // then, set (or remove) the recurrence ID
                if (model.recurrence) {
                    // pray that the reference was not lost during the _saveRecurrence() method
                    model.recurrence_id = model.recurrence.id ? [model.recurrence.id, '']: false;
                } else {
                    // in this case, it can be useful to remove the recurrence_id,
                    // if we allow (some day) to detach an occurrence from its recurrence
                    model.recurrence_id = false;
                }
                if (model.attendees && (model.attendeesFetched || !model.id)) {
                    var sanitizeAttendee = function (elt) {
                        var val = {
                            name: elt.name || '',
                            email: elt.email || '',
                            note: elt.note || '',
                            user_id: elt.user ? elt.user.id : false,
                            state: elt.state || false,
                        };
                        return val;
                    };
                    model.attendee_ids = swif.data.prepareOne2manyValues(
                        model.attendee_ids,
                        model.attendees,
                        sanitizeAttendee
                    );
                }

                if (model.prestations && (model.prestationsFetched || !model.id)) {
                    var sanitizePrestation = function (elt) {
                        var val = {
                            name: elt.name || '',
                            prestation_id: elt.prestation_id ? elt.prestation_id[0] : false,
                            price: elt.price || 0,
                            expected_date: elt.expected_date || false,
                            service_id: elt.service_id ? elt.service_id[0] : false,
                            prestation_state: elt.prestation_state || false
                        };
                        return val;
                    };
                    model.prestation_order_ids = swif.data.prepareOne2manyValues(
                        model.prestation_order_ids,
                        model.prestations,
                        sanitizePrestation
                    );
                }
                if (model.keys && (model.keysFetched || !model.id)) {
                    var sanitizeKey = function (elt) {
                        var val = {
                            key_id: elt.key_id ? elt.key_id[0] : false,
                            checkin: model.checkin,
                            checkout: model.checkout,
                            checkin_note: elt.checkin_note,
                            checkout_note: elt.checkout_note,
                            checkin_bookable_state: elt.checkin_bookable_state || false,
                            checkout_bookable_state: elt.checkout_bookable_state || false,
                            state: 'active',
                        };
                        return val;
                    };
                    model.key_ids = swif.data.prepareOne2manyValues(
                        model.key_ids,
                        model.keys,
                        sanitizeKey
                    );
                }
            }

        function save (model) {
            service.preSanitize(model);
            var ret;
            if(model.id) {
                ret = swif.data.save(model._type, model.id, model);
            }
            else {
                ret = swif.data.create(model._type, model);
            }

            return ret.then(function (data) {
                if(!model.id) {
                    model.id = data.result;
                }
                return true;
            });
        }

        function _updateOnWholeDay (model) {
            var day;
            if (model.whole_day) {
                if (!model.checkout) {
                    model.checkout = model.checkin;
                }
                if (model.checkout) {
                    day = model.checkout.slice(0, 10);
                    //23H59
                    model.checkout = swif.date.parseDatetime(day + ' 23:59:00');
                }
            } else if (!model.checkout){
                model.checkout = model.checkin;
            }
        }

    	return service;
    }

})();
